var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"aha-custom-tooltip",class:[_vm.position, { 'no-tooltip': !_vm.text && !_vm.html }]},[(_vm.text)?_c('p',[_vm._v("\n    "+_vm._s(_vm.text)+"\n  ")]):_vm._e(),(_vm.html)?_c('div',{staticClass:"aha-custom-tooltip__content",domProps:{"innerHTML":_vm._s(_vm.html)}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }